import { Box, Chip, Typography } from '@mui/material';

export const DemReconAIInsights = () => {
  const data = {
    chips: ['383 no discrepancy', '40 reconciled', '40 outstanding', 'Unresolved $14.1M'],
    oneLineSummary:
      'Discrepancies are down 20% vs the 3-month average, but $14.1M remains unresolved and is heavily concentrated in Medicaid.',
    bulletPoints: [
      'Total discrepancy dollars are $84.7M (−20% vs 3-month average), with $14.1M still unresolved.',
      'Outstanding exposure is primarily driven by Medicaid (~$8.15M), followed by smaller pockets in PHS (~$3.50M) and Returns (~$1.82M); all other channels are minimal.',
      'The majority of reductions are tied to product mapping fixes (~$61.8M combined) and RCM timing (~$8.9M), indicating remaining exposure is narrower and more concentrated.',
    ],
    fullSummary:
      'For the open month 2026M01, total discrepancy dollars are $84.7M, down 20% versus the trailing 3-month average, with $14.1M still unresolved. Reconciliation status shows 383 items with no discrepancy, alongside 40 reconciled and 40 outstanding, suggesting the remaining exposure is concentrated in a relatively small set of items. By channel, outstanding dollars are largely driven by Medicaid (~$8.15M), with additional contributions from PHS (~$3.50M) and Returns (~$1.82M), and only minor residual balances across ADAP, FSS, and Commercial; there is no notable outstanding exposure in US Gross Sales or NPVS.',
  };

  return (
    <>
      {/* KPI chips */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
        {data.chips.map((chip) => (
          <Chip key={chip} label={chip} variant="filled" sx={{ bgcolor: 'rgba(255,255,255,0.16)', color: 'inherit' }} />
        ))}
      </Box>

      {/* TL;DR */}
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        {data.oneLineSummary}
      </Typography>

      {/* Bulleted highlights */}
      <Box component="ul" sx={{ pl: 2.5, mt: 0, mb: 1.5, '& li': { mb: 0.5 } }}>
        {data.bulletPoints.map((bulletPoint, index) => (
          <li key={index}>
            <Typography variant="body2">{bulletPoint}</Typography>
          </li>
        ))}
      </Box>

      {/* Original narrative (narrow measure for readability) */}
      <Typography variant="body2" sx={{ lineHeight: 1.25 }}>
        {data.fullSummary}
      </Typography>

      {/* Micro-CTAs */}
      {/* <Box sx={{ display: 'flex', gap: 1.25, mt: 'auto', pt: 2 }}>
              <Button
                variant="contained"
                size="small"
                startIcon={<i className={fas.faBug} />}
                onClick={() => {
                  // example: open a filtered view for outliers
                  // setStartPeriod(...); setEndPeriod(...); setProdIds([...]);
                }}
              >
                View Outliers
              </Button>
              <Button
                variant="outlined"
                size="small"
                startIcon={<i className={fas.faLightbulb} />}
                onClick={() => {
                  // example: navigate to driver drilldown
                }}
                sx={{ color: 'inherit', borderColor: 'rgba(255,255,255,0.35)' }}
              >
                Driver Drilldown
              </Button>
            </Box> */}
    </>
  );
};
